/**
 * @file
 * Definitions for Audio Guide groups.
 * This is important because it contains CSS colours for the Audio Guides
 * that don't necessarily get defined elsewhere.
 * In future this should be moved to the Frontend Configuration field.
 * NOTE: Add both the node ID and UUID!
 */

const audioGuideGroups = (css) => {
  const paintingsGallery = {
    className: css.decoration__paintingsGuide,
    classNameInvert: css.decoration__paintingsGuide_invert,
    ctaButtonClassName: css.decoration__paintingsGuide__ctaButton,
    ctaButtonClassNameInvert:
      css.decoration__paintingsGuide_invert__ctaButton,
    backgroundColour: css.decorationcolourpaintingsguide,
    keyName: "field_ag_locations_color",
    groups: [
      {
        keyValues: ["#740658", "#5e4147", "#6c1b78"],
        groupTitle: "Room 1",
        //groupSubtitle: "001-104",
        groupSubtitle: "",
        showNumbers: true
      },
      {
        keyValues: ["#2976a0", "#4680a7"],
        groupTitle: "Room 2",
        //groupSubtitle: "105-207",
        groupSubtitle: "",
        showNumbers: true
      },
      {
        keyValues: ["#df521d", "#df5400"],
        groupTitle: "Room 3",
        //groupSubtitle: "208-302",
        groupSubtitle: "",
        showNumbers: true
      }
      //,
      // {
      //   capture: true,
      //   keyValues: [],
      //   groupTitle: "Recent acquisitions",
      //   groupSubtitle: "Found in Room 1",
      //   borderColour: "#740658",
      //   showNumbers: true
      // }
    ],
    backlinkText: "All paintings",
    locationTextSingle: "painting",
    nodeHeaderShowGuideHeader: false,
    inputVariant: "dark",
    hideBody: true
  };

  const paintingsKids = {
    component: "LearningAudioGuide",
    className: css.decoration__kidsAudioGuide,
    classNameInvert: css.decoration__kidsAudioGuide_invert,
    ctaButtonClassName: css.decoration__kidsAudioGuide__ctaButton,
    ctaButtonClassNameInvert:
      css.decoration__kidsAudioGuide_invert__ctaButton,
    backgroundColour: css.decorationcolourkidsaudioguide,
    keyName: "field_ag_locations_color",
    groups: [
      {
        capture: true,
        keyValues: [],
        groupTitle: "Room 1",
        groupSubtitle: "",
        borderColour: "#fff200",
        showNumbers: true
      }
    ],
    backlinkText: "All paintings",
    locationTextSingle: "painting",
    nodeHeaderShowGuideHeader: true,
    homepageLinks: {
      learningActivity: {
        title: "Learning Activity",
        href: "https://www.sl.nsw.gov.au/learning/composing-text-audio-guide",
        classNames: [
          css.decoration__kidsAudioGuide,
          css.learningActivityBackground
        ],
        buttonClassNames: [css.decoration__kidsAudioGuide__ctaButton]
      },
      aboutGuides: {
        title: "About Kids' Guides",
        href: "/kids-audio-guide/about",
        classNames: [
          css.decoration__kidsAudioGuide_invert,
          css.aboutGuidesBackground
        ],
        buttonClassNames: [css.decoration__kidsAudioGuide_invert__ctaButton]
      }
    },
    inputVariant: "dark"
  };

  const mapRooms = {
    className: css.decoration__mapsAudioGuide,
    classNameInvert: css.decoration__mapsAudioGuide_invert,
    ctaButtonClassName: css.decoration__mapsAudioGuide__ctaButton,
    ctaButtonClassNameInvert:
      css.decoration__mapsAudioGuide_invert__ctaButton,
    backgroundColour: css.decorationcolourmapsaudioguide,
    keyName: "field_ag_locations_color",
    groups: [
      {
        keyValues: ["#286a65"],
        groupTitle: "Heritage Map Room",
        groupSubtitle: "",
        borderColour: "#cc4a04",
        showNumbers: true
      },
      {
        keyValues: ["#542602"],
        groupTitle: "Michael Crouch Room",
        groupSubtitle: "",
        borderColour: "#cc4a04",
        showNumbers: true
      },
      {
        keyValues: ["#740658"],
        groupTitle: "Subdivision Maps",
        groupSubtitle: "",
        borderColour: "#cc4a04",
        showNumbers: false
      }
    ],
    backlinkText: "All maps",
    locationTextSingle: "map",
    nodeHeaderShowGuideHeader: true,
    inputVariant: "grey",
    navIgnoreAccentColour: true
  };

  const mapsOfThePacific = {
    className: css.decoration__mapsPacific,
    classNameInvert: css.decoration__mapsPacific_invert,
    ctaButtonClassName: css.decoration__mapsPacific__ctaButton,
    ctaButtonClassNameInvert: css.decoration__mapsPacific_invert__ctaButton,
    backgroundColour: css.decorationcolourmapspacific
  };

  const imagineExhibition = {
    className: css.decoration__imagineExhib,
    classNameInvert: css.decoration__imagineExhib_invert,
    ctaButtonClassName: css.decoration__imagineExhib__ctaButton,
    ctaButtonClassNameInvert: css.decoration__imagineExhib_invert__ctaButton,
    backgroundColour: css.decorationcolourimagineexhib
  };

  const prideRevolution = {
    className: css.decoration__prideRevolution,
    classNameInvert: css.decoration__prideRevolution_invert,
    ctaButtonClassName: css.decoration__prideRevolution__ctaButton,
    ctaButtonClassNameInvert: css.decoration__prideRevolution_invert__ctaButton,
    backgroundColour: css.decorationcolourpriderevolution,
  };

  const objectsGallery = {
    className: css.decoration__objectsGallery,
    classNameInvert: css.decoration__objectsGallery_invert,
    ctaButtonClassName: css.decoration__objectsGallery__ctaButton,
    ctaButtonClassNameInvert: css.decoration__objectsGallery_invert__ctaButton,
    backgroundColour: css.decorationcolourobjectsGallery,
  };

  return {
    "3": paintingsGallery,
    '8c9a1bdb-bf0d-40f4-a0bc-bc4f5857146a': paintingsGallery,
    "60": paintingsKids,
    'c25bd954-0773-4f24-9158-e92146ba0bc1': paintingsKids,
    "395": mapRooms,
    'abc4ee12-ec19-4b3f-bbdb-c438672c679f': mapRooms,
    "452": mapsOfThePacific,
    'e3d0ab87-4cb5-4eab-a8c0-7ebcd180976f': mapsOfThePacific,
    "486": imagineExhibition,
    '9401ae79-fb4c-4fb1-8660-c3d85614f0dd': imagineExhibition,
    '520': prideRevolution,
    '6cf4f189-580f-4cb2-a468-ea94bbd27900': prideRevolution,
    '550': objectsGallery,
    '6738cd46-1d03-42b0-984c-42f0e17e4527': objectsGallery,
  };
};

export default audioGuideGroups;
